// An INERT runtime form: the shared FormRenderer (the very renderer the Run
// view uses) over attribute columns, read-only, nothing saved — the setup
// screen's "How it looks" and Preview. The renderer needs the host's
// transaction runtime; where there is none (a designer surface without one)
// the person is told so instead of the screen breaking, and a render failure
// is caught the same way.

import { Component, type ReactNode } from 'react'
import type { SqlModel } from '../../txn/types'
import FormRenderer from '../../txn/FormRenderer'
import { useTxnRuntimeOptional } from '../../txn/context'

class Boundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null }
  static getDerivedStateFromError(error: Error) { return { error } }
  componentDidCatch(error: Error) { console.error('[uda setup] the preview could not be drawn', error) }
  render() {
    if (this.state.error) {
      return <div className="uds-na">The preview could not be drawn: {this.state.error.message}</div>
    }
    return this.props.children
  }
}

export default function PreviewForm({ model, values, project, objName, formNo, captions, headerValues }: {
  model: SqlModel
  values: Record<string, unknown>
  project: string
  objName: string
  formNo?: string
  captions?: Record<string, ReactNode>
  headerValues?: Record<string, unknown>
}) {
  const runtime = useTxnRuntimeOptional()
  if (!runtime) {
    return <div className="uds-na">The live preview shows here when this screen runs inside the application.</div>
  }
  if (!(model.columns || []).length) return <div className="uds-na">Nothing to show yet.</div>
  return (
    <Boundary>
      {/* inert: the real widgets, but nothing can be typed or clicked. */}
      <div inert style={{ pointerEvents: 'none' }}>
        <FormRenderer
          model={model} values={values} errors={{}} onChange={() => { /* inert */ }}
          readOnlyKey={false} project={project} objName={objName} formNo={formNo}
          headerValues={headerValues} groupCaptions={captions} layout="compact"
        />
      </div>
    </Boundary>
  )
}
